import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';

import CustomerView from '../../customerView/CustomerView';
import Dropdown from '../Dropdown/Dropdown';
import IconButton from '../common/IconButton/IconButton';
import AttributeRow from '../AttributeRow/AttributeRow';
import { getStaticCategories } from '../../Api';

import { Wrapper, BtnWrapperInline, BtnWrapper } from './Styled';
import { ToolTipSmall } from '../../components/common/TooltipLabel/styled'
import Tooltips from '../../config/Tooltips';

export default class AddNode extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedNode: this.props.selectedNode === "" ? "Select Node Type": this.props.selectedNode,
            attributes: [],
            addAttributeDisabled: true,
            selectableAttributes: this.props.selectableAttributes,
            selectableCategories: this.props.selectableCategories,
        };

        this.customerView = null;


        if (this.props.customerView !== null) {
            this.customerView = new CustomerView(this.props.customerView);
        }
    }

    componentWillMount() {
        this.setState({attributes: this.props.attributes});
    }

    componentWillReceiveProps(nextProps) {
        this.customerView = new CustomerView(nextProps.customerView);
        if (this.state.attributes !== nextProps.attributes) {
            let selectedNode = nextProps.selectedNode;
            let addAttributeDisabled = false;
            if(nextProps.selectedNode === "") {
                selectedNode = "Select Node Type";
                addAttributeDisabled = true;
            }

            /*/ clearing attribute state to reset
            the attributes then set them again /*/
            this.setState({ attributes: [], selectedNode: selectedNode, addAttributeDisabled: addAttributeDisabled }, () => {
                this.setState({attributes : nextProps.attributes, selectableAttributes: nextProps.selectableAttributes, selectableCategories: nextProps.selectableCategories});
            });
        }

    }

    handleNodeChange = (node) => {
        let selectableAttributes = this.customerView.getAttributes(node);
        let selectableCategories = getStaticCategories(node);
        this.setState({
            selectedNode: node,
            addAttributeDisabled: false,
            attributes:[],
            selectableAttributes,
            selectableCategories
        });

        this.props.nodeChanged(node, selectableAttributes, selectableCategories, this.props.nodeIndex);
        this.props.resetNodeAttributes(this.props.nodeIndex);
    }

    handleAddAttributeChange = () => {
        this.props.attributeAdded(this.props.nodeIndex);
    }

    handleAttributeChange = (attribute, attributeIndex) => {
        this.props.nodeAttributeChanged(attribute, this.props.nodeIndex, attributeIndex);
    }

    handleAttributeOperatorChange = (operator, attributeIndex) => {
        this.props.nodeAttributeOperatorChanged(operator, this.props.nodeIndex, attributeIndex);
    }

    handleAttributeValueChange = (value, attributeIndex) => {
        if (value != null && attributeIndex >= 0) {
            this.props.nodeAttributeValueChanged(value, this.props.nodeIndex, attributeIndex);
        }
        return;
    }

    handleDeleteAttribute = (id) => {
        this.props.nodeAttributeDeleted(id, this.props.nodeIndex);
    }

    removeBracesFromString = (string) => {
        return string.replace("{", "").replace("}", "");
    }

    render() {
        const selectNodeDropdown = (this.customerView !== null
            ? <Dropdown
                    id={this.props.id}
                    handleChange={this.handleNodeChange}
                    title="NODE TYPE"
                    selected={this.removeBracesFromString(this.state.selectedNode)}
                    hasOptionIcons={false}
                    options={this.props.selectableRelationshipNodes !== undefined ? this.props.selectableRelationshipNodes : this.customerView.getNodes()}/>
            : null);

        const attributefilters = (this.state.attributes.length === 0 ?
            <BtnWrapperInline>
                <IconButton text="Add Attribute" id={`add-row-btn-${this.props.nodeIndex}`} disabled={this.state.addAttributeDisabled} onClick={this.handleAddAttributeChange} iconName="fa fa-plus"/>
            </BtnWrapperInline>
            : this.state.attributes.map((attribute, index) =>
            <AttributeRow
                id={`attribute-row-${index}`}
                attributeId={attribute.id}
                attributeName={this.removeBracesFromString(attribute.property)}
                attributeClause={attribute.clause}
                attributeValue={attribute.value.includes('{') || attribute.value.includes("}") ? "" : attribute.value}
                handleAttributeChange={this.handleAttributeChange}
                handleAttributeOperatorChange={this.handleAttributeOperatorChange}
                handleAttributeValueChange={this.handleAttributeValueChange}
                handleDeleteAttribute={this.handleDeleteAttribute}
                attributes={this.state.selectableAttributes}
                categories={this.state.selectableCategories}
                attributeIndex={index}
                attributePlaceholder={"ENTER VALUE"}
                key={index}/>));

        const addButton = (this.state.attributes.length > 0 ?
                <BtnWrapper className="pb-2">
                    <Col xs={{ size: 7, offset: 5 }}>
                       <IconButton text="Add Attribute"
                            id={`add-row-btn-${this.props.nodeIndex}`}
                            disabled={this.state.addAttributeDisabled}
                            onClick={this.handleAddAttributeChange}
                            iconName="fa fa-plus"/>
                    </Col>
                </BtnWrapper> : null);

        return (
            <Wrapper className="mt-3">
                <Row>
                    <Col xs={{ size: 11, offset: 1 }} className="pr-0">
                        <ToolTipSmall id={this.props.id} item={Tooltips.nodeTypeDescription} placement="left" colSize={1} className="pull-right text-right mt-1 mb-2 pr-2"/>
                    </Col>
                </Row>
                <Row>
                    <Col xs={{ size: 3, offset: 1 }}>{selectNodeDropdown}</Col>
                    <Col xs="1" className="pt-3 pl-0 pr-0 text-center ">WHERE</Col>
                    <Col xs="7">{attributefilters}</Col>
                </Row>
               {addButton}
            </Wrapper>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/AddNode/AddNode.js